export default __webpack_public_path__ + "static/Saly-24-cfea8c6524bcd5c943f93b68869ea443.png";